export default __webpack_public_path__ + "eddfc9075e24e637daf312f370716ba0.png";